import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'
import { RouterModule } from "@angular/router"
import { HandGuardGuard } from "./hand-guard.guard"
// import { MatMenuModule } from '@angular/material/menu';
// import { MatIconModule } from '@angular/material/icon';
// import { MatButtonModule } from '@angular/material/button';
// MatIconModule

import { AppMaterialModule } from './material-module';

import { MainRoutes } from './Poker.MainRouting';
import { MainComponent } from './Poker.MainComponent';
import { HandComponent } from './Poker.HandComponent';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    MainComponent
  ],
  imports: [
    RouterModule.forRoot(MainRoutes),
    BrowserModule, FormsModule, NgbModule,
    BrowserAnimationsModule,
    AppMaterialModule,
    //ReactiveFormsModule
    // MatMenuModule, MatIconModule, MatButtonModule
  ],
  providers: [HandGuardGuard],
  bootstrap: [HandComponent]
})
export class MainModule { }
